import { ReferralRole } from '../../../types/graphqlTypes';

/** Mirrors the server's referral/helpers/settings.ts: which roles earn money, order for their customers, support them. */
export const isPartnerRole = (role: ReferralRole | undefined): boolean => role === ReferralRole.LeadGenerator || role === ReferralRole.Reseller || role === ReferralRole.FullService;

// Resellers and full-service partners order for their customers and are billed for them: the customer center is theirs.
export const ordersForCustomers = (role: ReferralRole | undefined): boolean => role === ReferralRole.Reseller || role === ReferralRole.FullService;

// Only a full-service partner supports its customers, so only it may look into their organisations.
export const supportsCustomers = (role: ReferralRole | undefined): boolean => role === ReferralRole.FullService;

// A cut in basis points as a percentage: 2000 → "20", 1250 → "12.50".
export const cutPercent = (basisPoints: number): string => (basisPoints / 100).toFixed(basisPoints % 100 === 0 ? 0 : 2);
